import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  opinionBox: {
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
  },
}))

export default styles
